import { Container } from "@/components/atoms";
import { PageHeader, PrivateNetworkHistoryPanel } from "@/components/organisms";

export const PrivateNetworkHistory = () => {
  return (
    <Container className="mb-12 flex w-full flex-1 flex-col">
      <PageHeader title="Private Network" skipCrumbs={1} />
      <PrivateNetworkHistoryPanel />
    </Container>
  );
};
